import datetimeFormats from './dateTimeFormats'
import numberFormats from './numberFormats'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  datetimeFormats,
  numberFormats,
}))
